import React from "react";

interface ProgressBarProps {
  value: number;
  max: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ value, max }) => {
  const percent = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
      }}
    >
      <div
        style={{
          flex: 1,
          background: "var(--color-surface)",
          borderRadius: 6,
          height: 5,
          width: "100%",
          marginRight: 8,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          style={{
            width: `${percent}%`,
            background: "var(--color-primary)",
            height: "100%",
            borderRadius: 6,
            transition: "width 0.3s",
          }}
        />
      </div>
      <div
        style={{
          color: "var(--color-white)",
          fontSize: 10,
          fontWeight: 600,
          textAlign: "right",
        }}
      >
        {value}/{max}
      </div>
    </div>
  );
};

export default ProgressBar;
